var _g, _path, _rect, _rect2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulbon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#F5B400",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0.4v1.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.6 3.9l.9.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4 3.9l-.9.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.8 10h1.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9 10h1.3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.5a6.5 6.5 0 0 0-3.9 11.7c.6.5.9 1.1.9 1.8V17h6v-1c0-.7.3-1.3.9-1.8A6.5 6.5 0 0 0 12 2.5z",
    fill: "#FFD60A",
    stroke: "#333333",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 17.6,
    width: 6,
    height: 1.6,
    rx: 0.5,
    fill: "#9E9E9E",
    stroke: "#333333",
    strokeWidth: 0.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.6,
    y: 19.6,
    width: 4.8,
    height: 1.6,
    rx: 0.5,
    fill: "#9E9E9E",
    stroke: "#333333",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 21.6h2",
    stroke: "#333333",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulbon);
export default __webpack_public_path__ + "static/media/bulbon.8bbaba11aa159b2a3dc8e7e1a5b00615.svg";
export { ForwardRef as ReactComponent };